<template>
    <DataSortFilter v-bind="$attrs" :model-value="modelValue" label="Sort by:" :options="options" />
</template>

<script lang="ts">
export const defaultFontsSortBy = "name_ASC";
</script>

<script setup lang="ts">
import DataSortFilter, { type DataSortFilterOptions } from "@/components/DataSortFilter.vue";

const { modelValue } = defineProps({
    modelValue: {
        type: String,
        default: defaultFontsSortBy
    }
});

const options: DataSortFilterOptions[] = [
    {
        field: "Name",
        ascValue: "name_ASC",
        ascOptionDirection: "A to Z",
        descValue: "name_DESC",
        descOptionDirection: "Z to A"
    }
];
</script>
